export default __webpack_public_path__ + "static/media/btnAndroid.f3680376.svg";